"use client";
import { jsx as t, jsxs as r } from "react/jsx-runtime";
import { Link as m, Group as o, Icon as s, Paragraph as _ } from "@ingeniorforeningen/figurine-core";
import { forwardRef as u } from "react";
import '../../../../assets/ClusterItemFile.css';const g = "_root_npaw7_2", h = "_group_npaw7_6", w = "_content_npaw7_12", x = "_text_npaw7_21", d = "_icon_npaw7_26", e = {
  root: g,
  group: h,
  content: w,
  text: x,
  icon: d
}, a = u(
  (c, l) => {
    const { text: i, link: n, ...p } = c;
    return /* @__PURE__ */ t(m, { href: n.href, target: n.target, ref: l, className: e.root, children: /* @__PURE__ */ r(o, { ...p, className: e.group, children: [
      /* @__PURE__ */ t(o, { className: e.icon, children: /* @__PURE__ */ t(s, { name: "Download", size: "xl", stroke: 1.25 }) }),
      /* @__PURE__ */ r(o, { pl: 0, className: e.content, wrap: "nowrap", children: [
        /* @__PURE__ */ t(_, { lineClamp: 3, text: i, strong: !0, className: e.text }),
        /* @__PURE__ */ t(s, { name: "ChevronRight" })
      ] })
    ] }) });
  }
);
a.displayName = "FlieClusterItem";
const I = a;
export {
  a as _ClusterItemFile,
  I as default
};
